import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { rentalAPI, aud } from '../../lib/rentalRegisterAPI';

export const GST_LABELS = [['G1', 'Total sales'], ['G3', 'GST-free sales'], ['G4', 'Input-taxed sales'], ['1A', 'GST on sales'], ['G10', 'Capital purchases'], ['G11', 'Non-capital purchases'], ['1B', 'GST credits']];

export const GstFigures = ({ f, testid }) => (
  <div className="grid grid-cols-4 md:grid-cols-7 gap-1" data-testid={testid}>{GST_LABELS.map(([k, l]) => (
    <div key={k} className="rounded border px-2 py-1"><div className="text-[10px] text-muted-foreground">{k} · {l}</div><div className="text-xs font-medium" data-testid={`${testid}-${k}`}>{aud(f[k])}</div></div>))}</div>
);

export const GstSummaryCard = ({ id }) => {
  const [s, setS] = useState(null);
  useEffect(() => { rentalAPI.gstSummary(id).then(setS).catch(() => setS(false)); }, [id]);
  if (!s) return null;
  return (
    <div className="rounded-md border border-sky-200 bg-sky-50/50 p-2 space-y-1 text-xs" data-testid="task-gst-summary">
      <p className="font-medium">Rental GST summary · {s.label} <span className="text-muted-foreground">({s.cycle})</span></p>
      <GstFigures f={s.figures} testid="task-gst" />
      <p className="text-muted-foreground">{s.properties.map((p) => `${p.address} (${p.share}%${p.entity_level ? ', entity level' : ''})`).join(' · ')}</p>
      <p className="text-amber-800">{s.disclaimer}. Not lodged — no ATO connection.</p>
      <Link className="underline" to={`/clients/${s.client_id}?tab=rental`}>Open client rental</Link>
    </div>
  );
};
